export default [
  { name: 'description', content: 'Availity UIKit powered by Bootstrap 4' },
  { name: 'keywords', content: 'css, bootstrap, uikit' },
];



// WEBPACK FOOTER //
// ./src/layouts/meta.js